export const FETCH_USERS_COMPACT_REQUEST = '@sku/FETCH_USERS_COMPACT_REQUEST';
export const FETCH_USERS_COMPACT_SUCCESS = '@sku/FETCH_USERS_COMPACT_SUCCESS';
export const FETCH_USERS_COMPACT_FAILED = '@sku/FETCH_USERS_COMPACT_FAILED';
